import { DealClassifierTct } from '@dealstack/shared/lib/generated';

export interface DealClassifierWithSubRows extends DealClassifierTct {
	subRows?: DealClassifierWithSubRows[];
}

export const mapClassifiersToTableData = (classifiers: DealClassifierTct[] = []) => {
	const mapClassifier = (classifier: DealClassifierTct): DealClassifierWithSubRows => {
		return {
			...classifier,
			subRows:
				classifier.children && classifier.children.length > 0
					? classifier.children.map(mapClassifier)
					: undefined,
		};
	};

	return classifiers.map(mapClassifier);
};
